import { apiFetch } from '@/shared/api/client'

/** Baris material pada satu dispatch dalam trip (§4 warehouse-gudang-api.md). */
export type TripDispatchLine = {
  id: string
  material_id: string
  material_code: string
  material_name: string
  uom: string
  qty: number
}

/** Satu dispatch (kiriman ke dapur) dalam trip delman. */
export type TripDispatchItem = {
  id: string
  code: string
  target_kitchen_name: string
  status: string
  dispatched_at?: string
  lines: TripDispatchLine[]
}

/** Trip delman gudang (§4 warehouse-gudang-api.md). */
export type DispatchTrip = {
  id: string
  trip_code: string
  warehouse_name: string
  delman_name: string
  date: string
  status: 'dispatched' | 'in_progress' | 'completed' | 'cancelled' | string
  dispatched_at?: string
  started_at?: string
  completed_at?: string
  dispatches: TripDispatchItem[]
}

/** GET /warehouse/dispatch-trips?date=YYYY-MM-DD (default hari ini). */
export async function fetchTrips(date?: string): Promise<DispatchTrip[]> {
  const qs = date ? `?date=${encodeURIComponent(date)}` : ''
  const res = await apiFetch<{ items: DispatchTrip[] }>(`/warehouse/dispatch-trips${qs}`)
  return res.items ?? []
}

/** GET /warehouse/dispatch-trips/{tripId}. */
export async function fetchTrip(tripId: string): Promise<DispatchTrip> {
  return apiFetch<DispatchTrip>(`/warehouse/dispatch-trips/${encodeURIComponent(tripId)}`)
}

export type TripActionResponse = {
  trip_id: string
  status: string
  updated_at: string
}

/** PATCH /warehouse/dispatch-trips/{tripId}/start — trip harus 'dispatched'. */
export async function startTrip(tripId: string): Promise<TripActionResponse> {
  return apiFetch<TripActionResponse>(`/warehouse/dispatch-trips/${encodeURIComponent(tripId)}/start`, {
    method: 'PATCH',
  })
}

/** PATCH /warehouse/dispatch-trips/{tripId}/complete — trip harus 'in_progress'. */
export async function completeTrip(tripId: string): Promise<TripActionResponse> {
  return apiFetch<TripActionResponse>(`/warehouse/dispatch-trips/${encodeURIComponent(tripId)}/complete`, {
    method: 'PATCH',
  })
}

export type GenerateQrResponse = {
  token: string
  payload: string
  expires_at: string
}

/** POST /warehouse/dispatches/{dispatchId}/generate-qr — hanya delman pemilik trip. */
export async function generateDispatchQr(dispatchId: string): Promise<GenerateQrResponse> {
  return apiFetch<GenerateQrResponse>(`/warehouse/dispatches/${encodeURIComponent(dispatchId)}/generate-qr`, {
    method: 'POST',
  })
}
